<template>
  <v-container>
    <v-row>
      <v-col cols="12" class="text-center">
        <v-progress-circular indeterminate class="primary--text" width="7" size="70" v-if="loading"></v-progress-circular>
      </v-col>
    </v-row>
    <v-container fluid>
      <v-row justify="center">
        <v-col cols="12" sm="4">
          <v-card min-height="410" elevation="0" outlined>
            <v-img
              class="white--text"
              height="200px"
              src="/images/products/tools-tile1.jpg"
            >
            </v-img>
            <v-card-title>
              <h3 class="headline mb-0">Separation Statement</h3>
            </v-card-title>
            <v-card-text>
              Fill out the form following the prompts and take your Separation Statement with you to your initial consultation with your lawyer.
            </v-card-text>
            <v-card-actions class="justify-center">
              <v-btn color="teal" dark to="/products/separation-statement">Open</v-btn>
              <v-btn color="teal" dark outlined href="https://divorceanswered.com.au/separation-statement/" target="_blank">More Info</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col cols="12" sm="4">
          <v-card min-height="410" elevation="0" outlined>
            <v-img
              class="white--text"
              height="200px"
              src="/images/products/tools-tile5.jpg"
            >
            </v-img>
            <v-card-title>
              <h3 class="headline mb-0">Budget Tool</h3>
            </v-card-title>
            <v-card-text>
              The Divorce Answered Budget Tool offers an insight into your income and expenditure.
              <br><br>
            </v-card-text>
            <v-card-actions class="justify-center">
              <v-btn color="teal" dark to="/products/budget-tool">Open</v-btn>
              <v-btn color="teal" dark outlined href="https://divorceanswered.com.au/budget-tool/" target="_blank">More Info</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col cols="12" sm="4">
          <v-card min-height="410" elevation="0" outlined>
            <v-img
              class="white--text"
              height="200px"
              src="/images/products/tools-tile2.jpg"
            >
            </v-img>
            <v-card-title>
              <h3 class="headline mb-0">Separation Checklist</h3>
            </v-card-title>
            <v-card-text>
              This comprehensive list gives you a thorough list of considerations and items that may need addressing or compiling.
            </v-card-text>
            <v-card-actions class="justify-center">
              <v-btn color="teal" dark to="/products/checklists">Open</v-btn>
              <v-btn color="teal" dark outlined href="https://divorceanswered.com.au/separation-checklist/" target="_blank">More Info</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
      <v-row justify="center" class="mt-4">
        <v-col cols="12" sm="6">
          <v-card elevation="0" outlined>
            <v-img
              class="white--text"
              height="200px"
              src="/images/products/tools-tile4.jpg"
            >
            </v-img>
            <v-card-title>
              <h3 class="headline mb-0">Binding Child Support Agreement</h3>
            </v-card-title>
            <v-card-text>
              Before you get to the point of angst or frustration, the BCSA is like a costs agreement on items beyond minimum Child Support.
            </v-card-text>
            <v-card-actions class="justify-center">
              <v-btn color="teal" dark to="/products/binding-child-support-agreement">Open</v-btn>
              <v-btn color="teal" dark outlined href="https://divorceanswered.com.au/binding-child-support-agreement/" target="_blank">More Info</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6">
          <v-card elevation="0" outlined>
            <v-img
              class="white--text"
              height="200px"
              src="/images/products/tools-tile3.jpg"
            >
            </v-img>
            <v-card-title>
              <h3 class="headline mb-0">Parenting Plan</h3>
            </v-card-title>
            <v-card-text>
              The parenting plan offers you peace of mind and a structure that allows you and your child to make the most of your time together.
            </v-card-text>
            <v-card-actions class="justify-center">
              <v-btn color="teal" dark to="/products/parenting-plan">Open</v-btn>
              <v-btn color="teal" dark outlined href="https://divorceanswered.com.au/parenting-plan/" target="_blank">More Info</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
      <!-- Ebooks -->
      <v-row justify="center" class="mt-4">
        <v-col cols="12" md="4" sm="6">
          <v-card min-height="330" elevation="0">
            <v-img
              class="white--text"
              height="150px"
              contain
              src="/images/products/prod4.jpg"
            >
            </v-img>
            <v-card-title class="justify-center text-center">
              <h3 class="headline mb-0">15 Biggest Mistakes Made In Divorce</h3>
            </v-card-title>
            <v-card-actions class="justify-center">
              <v-btn color="teal" dark @click="downloadEbook('ebooks/15-Biggest-Mistakes-Made-in-Divorce.pdf')">Download Ebook</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col cols="12" md="4" sm="6">
          <v-card min-height=330 elevation=0>
            <v-img
              class="white--text"
              height="150px"
              contain
              src="/images/products/prod7.jpg"
            >
            </v-img>
            <v-card-title class="justify-center text-center">
              <h3 class="headline mb-0">Everyday Grattitude and Mindfulness During Divorce</h3>
            </v-card-title>
            <v-card-actions class="justify-center">
              <v-btn color="teal" dark @click="downloadEbook('ebooks/Everyday-Grattitude-And-Mindfulness-During-Divorce.pdf')">Download Ebook</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col cols="12" md="4" sm="6">
          <v-card min-height=370 elevation=0>
            <v-img
              class="white--text"
              height="150px"
              contain
              src="/images/products/ebook-domestic-violence.jpg"
            >
            </v-img>
            <v-card-title class="justify-center text-center">
              <div>
                <span>eBook: How to best separate:</span>
                <h3 class="headline mb-2">Domestic Violence</h3>
                <h3 class="headline text-md-center teal--text mb-0">AU$19</h3>
              </div>
            </v-card-title>
            <v-card-actions class="justify-center">
              <v-btn color="teal" dark outlined to="/ebooks/domestic-violence">More Info</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col cols="12" md="4" sm="6">
          <v-card min-height=370 elevation=0>
            <v-img
              class="white--text"
              height="150px"
              contain
              src="/images/products/ebook-mental-health-and-wellbeing.jpg"
            >
            </v-img>
            <v-card-title class="justify-center text-center">
              <div>
                <span>eBook: How to best separate:</span>
                <h3 class="headline mb-0">Mental Health And Wellbeing</h3>
                <h3 class="headline text-md-center teal--text mb-0">AU$19</h3>
              </div>
            </v-card-title>
            <v-card-actions class="justify-center">
              <v-btn color="teal" dark outlined to="/ebooks/mental-health">More Info</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col cols="12" md="4" sm="6">
          <v-card min-height=370 elevation=0>
            <v-img
              class="white--text"
              height="150px"
              contain
              src="/images/products/ebook-narcissist.jpg"
            >
            </v-img>
            <v-card-title class="justify-center text-center">
              <div>
                <span>eBook: How to best separate:</span>
                <h3 class="headline mb-0">From A Narcissist</h3>
                <h3 class="headline text-md-center teal--text mb-0">AU$19</h3>
              </div>
            </v-card-title>
            <v-card-actions class="justify-center">
              <v-btn color="teal" dark outlined to="/ebooks/how-to-separate-from-a-narcissist">More Info</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col cols="12" md="4" sm="6">
          <v-card min-height=370 elevation=0>
            <v-img
              class="white--text"
              height="150px"
              contain
              src="/images/products/ebook-when-relationship-ends.jpg"
            >
            </v-img>
            <v-card-title class="justify-center text-center">
              <div>
                <span>eBook: How to best separate:</span>
                <h3 class="headline mb-0">When Your Relationship Ends</h3>
                <h3 class="headline text-md-center teal--text mb-0">AU$19</h3>
              </div>
            </v-card-title>
            <v-card-actions class="justify-center">
              <v-btn color="teal" dark outlined to="/ebooks/how-to-separate-when-relationship-ends">More Info</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col cols="12" md="4" sm="6">
          <v-card min-height=370 elevation=0>
            <v-img
              class="white--text"
              height="150px"
              contain
              src="/images/products/ebook-100-ways-to-save.jpg"
            >
            </v-img>
            <v-card-title class="justify-center text-center">
              <div>
                <span>eBook: How to best separate:</span>
                <h3 class="headline mb-0">100+ Ways To Save At Home</h3>
                <h3 class="headline text-md-center teal--text mb-0">AU$19</h3>
              </div>
            </v-card-title>
            <v-card-actions class="justify-center">
              <v-btn color="teal" dark outlined to="/ebooks/how-to-separate-100-ways-to-save-at-home">More Info</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <app-complete-account-dialog :show="showCompleteAccountDialog" :account="account"></app-complete-account-dialog>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    dialog: false,
    version: process.env.VUE_APP_VERSION
  }),
  computed: {
    account () {
      return this.$store.getters['accounts/loadedAccount']
    },
    meetups () {
      return this.$store.getters.featuredMeetups
    },
    loading () {
      return this.$store.getters.loading
    },
    showCompleteAccountDialog () {
      return this.account.firstName?.length === 0 || this.account.lastName?.length === 0
    }
  },
  methods: {
    downloadEbook (url) {
      this.$store.dispatch('download/sign', url).then(protectedURL => {
        window.location = protectedURL
      })
    }
  },
  created () {
    this.$store.dispatch('accounts/loadAccount', this.$store.getters.user.id)
  }
}
</script>

<style scoped>
  .title {
    position: absolute;
    bottom: 50px;
    background-color: rgba(0,0,0,0.5);
    color: white;
    font-size: 2em;
    padding: 20px
  }
</style>
